export default __webpack_public_path__ + "static/Hero-ff86cf32cd0a5ab7ced5b5b9f0edccc2.mp4";